import React, { useEffect } from 'react';
import { Route, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import protectedRoutes from '../../../constants/protected-routes';
import { logout } from '../../../redux/features/userSlice';
import RoutesConstant from '../../../constants/routes';
import { getCookie } from '../../../utils/cookie-storage/cookie-storage';

const ProtectedRoutes = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const protectedPathNames = protectedRoutes.map((e) => e.path);
  const user = useSelector((state) => state?.user?.user);
  const token = getCookie("auth-token");
  const currentPath = window.location.pathname;

  useEffect(() => {
    if (!token) {
      if (protectedPathNames.includes(currentPath)) {
        dispatch(logout());
        navigate(RoutesConstant.LOGIN);
      }
      return;
    }
    
    if (user?.role === 'ADMIN') {
      if (user?.is_first_login && currentPath !== RoutesConstant.RESET_PASSWORD_FIRST_LOGIN) {
        navigate(RoutesConstant.RESET_PASSWORD_FIRST_LOGIN);
      } else if (!user?.is_first_login && currentPath === RoutesConstant.RESET_PASSWORD_FIRST_LOGIN) {
        navigate(RoutesConstant.DASHBOARD);
      }
    }
  }, [token, user, currentPath, navigate, dispatch]);

  return (
    <>
      {protectedRoutes.map((e, i) => {
        const Component = e?.component;
        return <Route key={i} path={e?.path} element={<Component />} />;
      })}
    </>
  );
};

export default ProtectedRoutes;
